<template>
    <div class="message-thread-list-item" :class="{ unread: !seen, active: active }">
        <avatar :avatar="avatar" class="avatar"></avatar>
        <div class="time">{{date | adaptiveTime}}</div>
        <div class="title">{{name}}</div>
        <div class="description">{{subject}}</div>
    </div>
</template>

<script>
    import Avatar from '../../components/Avatar'

    export default {
        name: "message-list-item",

        props: {
            date: {
                type: [Date, String],
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            avatar: {
                type: Object,
                required: false,
            },
            subject: {
                type: String,
                required: true,
            },
            active: {
                type: Boolean,
                default: false
            },
            seen: {
                type: Boolean,
            },
        },

        components: { Avatar }
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    $border-color: #e8e8e8;

    .message-thread-list-item {
        $message-item-padding: 20px;
        cursor: pointer;
        padding: px-em($message-item-padding) px-em($message-item-padding) px-em($message-item-padding) px-em($message-item-padding + 48px + 16px);
        border-bottom: 1px solid $border-color;
        position: relative;
        min-height: 48px + $message-item-padding * 2;

        @include clearfix;

        .title {
            font-weight: bold;
        }

        .avatar {
            width: px-em(48px);
            height: px-em(48px);
            left: px-em($message-item-padding);
            top: px-em($message-item-padding);
            position: absolute;
            margin-right: 1em;
        }

        .description,
        .time {
            color: #a6b4c0;
        }


        .time {
            float: right;
            font-size: 12px / 16px + em;
        }

        .description,
        .title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &.unread {
            background-color: lighten($body-background, 2.5%);
        }

        &.active {
            box-shadow: inset -3px 0 0 $color-green;

            .title {
                color: $color-green;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/inbox/MessageListItem.vue